import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Category - Get All (Read)
export const GetAllHistory = createAsyncThunk(
  "admin/roulette/all-history",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Games.Roulette}/history?name=${filter?.name || ""}&uid=${filter?.uid || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${
          filter?.email || ""
        }&contact=${filter?.contact || ""}&start_date=${
          filter?.startDate || ""
        }&end_date=${filter?.endDate || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllwinningHistory = createAsyncThunk(
  "admin/roulette/all-winning-history",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Games.Roulette}/winning-history?name=${filter?.name || ""}&uid=${filter?.uid || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${
          filter?.email || ""
        }&contact=${filter?.contact || ""}&start_date=${
          filter?.startDate || ""
        }&end_date=${filter?.endDate || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetSummaryData = createAsyncThunk(
  "admin/roulette/summary-data",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Games.Roulette}/summary_data?name=${filter?.name || ""}&uid=${filter?.uid || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${
          filter?.email || ""
        }&contact=${filter?.contact || ""}&start_date=${
          filter?.startDate || ""
        }&end_date=${filter?.endDate || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "roulette",
  initialState: {
    data: [],
    summary_data: {},
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetCategory, AddCategory, UpdateCategory, DeleteCategory
      .addCase(GetAllHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetAllwinningHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(GetAllwinningHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllwinningHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSummaryData.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSummaryData.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.summary_data = action.payload?.data || [];
      })
      .addCase(GetSummaryData.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
